const SLOT_VALUE_CENTS = 80_000;

function formatCurrency(cents: number): string {
  const value = Number.isFinite(cents) ? cents / 100 : 0;
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

interface SlotProgressProps {
  amountCents: number;
  targetCents?: number;
  className?: string;
}

export default function SlotProgress({ amountCents, targetCents = SLOT_VALUE_CENTS, className }: SlotProgressProps) {
  const safeTarget = targetCents > 0 ? targetCents : SLOT_VALUE_CENTS;
  const clamped = Math.max(0, Math.min(amountCents || 0, safeTarget));
  const percent = Math.min(100, Math.round((clamped / safeTarget) * 100));
  const remaining = Math.max(0, safeTarget - clamped);

  return (
    <div className={`space-y-2${className ? ` ${className}` : ''}`}>
      <div className="flex items-center justify-between text-sm text-cocoa/80">
        <span className="font-medium text-cocoa">Progress to next slot</span>
        <span className="tabular-nums text-cocoa">{percent}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-sand">
        <div
          className="h-full rounded-full bg-cocoa transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-sm text-cocoa">
        <span className="font-medium">{formatCurrency(remaining)}</span> to mint the next classroom slot.
      </p>
    </div>
  );
}
